<template>
  <custom-dialog :visible="visible" width="1180px" :title="model.title" v-on="$listeners">
    <div class="dialog-body">
      <div class="item-title">{{ $t('dms_device_location_dialog.she_bei_xin_xi') }}</div>
      <custom-table :data="tableList" :index="true" tableCode="deviceProject" @filter="filterChange" @sort="sortChange" :filterArr="['locationName']"></custom-table>
      <div class="item-title" style="margin-top: 16px">{{ $t('dms_device_location_dialog.shi_yong_di_dian') }}</div>
      <el-form :model="form" ref="form" size="mini" label-width="auto" :rules="rules">
        <el-form-item :label="$t('dms_device_location_dialog.xiang_mu')">
          <el-input type="textarea" rows="3" v-model="form.useLocation"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" @click="onSave">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      tableList: [],
      form: {
        useLocation: '',
      },
    };
  },
  mounted() {
    this.getDeviceInfo();
  },

  computed: {
    rules() {
      return {
        useLocation: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
  },
  methods: {
    // 获取设备信息
    getDeviceInfo() {
      this.$getJSON(`${apis.DeviceInfo}/${this.model.data.deviceId}`).then((res) => {
        this.tableList = [res.data];
      });
    },
    // 保存提交
    onSave() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.$postJSON(apis.DeviceMyUpdate, {
            deviceId: this.model.data.deviceId,
            useLocation: this.form.useLocation,
          }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.$emit('success');
            this.visible = false;
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.device-location-dialog {
  .el-form-item__label {
    width: 100%;
    text-align: left;
  }

  .el-select {
    width: 100%;
  }

  .dialog-body {
    height: 413px;
    width: 100%;
    padding: 0 !important;
    display: flex;
    border-bottom: 1px solid #e9ebec;
    .msg-content {
      width: 260px;
      padding: 0 24px;
      height: 100%;
      background: #f8f9fb;
      .title {
        $h: 60px;
        height: $h;
        line-height: $h;
        color: #495057;
        font-weight: bold;
        font-size: 14px;
      }
      .msg-list {
        > li {
          overflow: hidden;
          padding-top: 9px;
          padding-bottom: 10px;
          color: #6c757d;
          font-size: 12px;
          line-height: 17px;
          border-bottom: 1px solid #eef2f7;
          .key {
            float: left;
            width: 50%;
          }
          .val {
            float: left;
            text-align: right;
            width: 50%;
          }
        }
      }
    }
    .input-container {
      flex: 1;
      padding: 24px 24px 0 24px;
      background: #fff;
    }
  }
}
</style>
